import _fillInstanceProperty from "@babel/runtime-corejs3/core-js/instance/fill";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueContentLoading from "vue-content-loading";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PDFPreviewLoader",
  components: {
    VueContentLoading
  },
  data() {
    var _context;
    const rows = 2;
    const columns = 5;
    const coverHeight = 85;
    const coverWidth = 65;
    const padding = 5;
    const speed = 1;
    return {
      rows,
      columns,
      coverHeight,
      coverWidth,
      padding,
      speed,
      coverHeightWithPadding: coverHeight + padding,
      coverWidthWithPadding: coverWidth + padding,
      initial: 10,
      covers: _fillInstanceProperty(_context = Array(columns * rows)).call(_context, 1)
    };
  },
  computed: {
    rectWidth() {
      return this.columns * this.coverWidthWithPadding - this.padding;
    }
  },
  methods: {
    getVy(index, columns) {
      return Math.floor(index / columns) * this.coverHeightWithPadding + this.initial;
    },
    getVx(index, columns) {
      return index * this.coverWidthWithPadding % (columns * this.coverWidthWithPadding);
    }
  }
});